import { bus } from "@/main";
import VueCookies from "vue-cookies";
import { ProjectApplication } from "@/data/classes/project.class";
import { createProjectEntry, getProjectsList } from "@/data/models/project.model";
import { getSchoolsList } from "@/data/models/school.model";

export default {
	name: "ProjectsPage",
	data() {
		return {
			content: null,
			isReady: false,
			currentPage: 1,
			disableKeywords: false,
			keywords: [
				{ label: "Comunicação", slug: 'comunication' },
				{ label: "Mix Media", slug: 'mix_media' },
				{ label: "Design Estratégico", slug: 'design_strategy' },
				{ label: "Gestão do Design", slug: 'design_management' },
				{ label: "Editorial", slug: 'editorial' },
				{ label: "Ilustração", slug: 'illustration' },
				{ label: "Industrial", slug: 'industrial' },
				{ label: "Produto", slug: 'product' },
				{ label: "Design Social", slug: 'social_design' },
				{ label: "Joalharia", slug: 'jewelry' },
				{ label: "Software", slug: 'software' },
				{ label: "Packaging", slug: 'packaging' },
				{ label: "Set Design", slug: 'set_design' },
				{ label: "Tipografia", slug: 'typography' },
				{ label: "Web Design", slug: 'web_design' },
				{ label: "Interação", slug: 'interaction' },
				{ label: "Food Design", slug: 'food_design' },
				{ label: "Design de Ambientes", slug: 'ambient_design' },
				{ label: "Craft Design", slug: 'craft_design' },
				{ label: "Infodesign", slug: 'info_design' },
				{ label: "Design de Moda", slug: 'fashion_design' },
			],
		}
	},
	created () {
		this.getContent();
		bus.$on("deleteSession", () => {
			this.getContent();
		})
		bus.$on("userSession", () => {
			this.getContent();
		})
		bus.$on("projectDeleted", () => {
			console.log("Project DELETED !!!")
			this.content = null;
			this.getContent();
		})
	},
	computed: {
		pageUrl: function() {
			return location.href;
		}
	},
	mounted () {},
	watch: {
		"$route": function () {
			this.getContent();
			language: this.$route.params.lang
		}
	},
	methods: {
		async getContent() {
			let user = VueCookies.get("user")
			await getProjectsList(1, 1, "", 100).then(content => {
				this.content = content;
				this.isReady = true;
				this.totalPages = content.totalPages;
				this.totalEntries = content.totalEntries;
			});
			getProjectsList(1, 2, "", 100).then(content => {
				content.content.forEach(element => {
					this.content.content.push(element);
				});
				this.totalPages = content.totalPages;
				this.totalEntries = content.totalEntries;
			});
		},
		evalKeyword(value, compare) {
			if (compare && compare.length >= 3)
				this.disableKeywords = true;
			else
				this.disableKeywords = false;
			
			if (compare && compare.includes(value))
				return true;
			else
				return false;
		},
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/output/output.page.js